import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { PaymentDashboard } from '~pages/payments/payment-dashboard/index';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const paymentDashboardSearchSchema = z.object({
  id: z.string().optional(),
});

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute(
  '/_auth/_layout/payment/payment-dashboard',
)({
  validateSearch: zodValidator(paymentDashboardSearchSchema),
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: PaymentDashboard,
});
